// extracted by mini-css-extract-plugin
export default {"page":"hardware_page__0G7iZ"};